import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../components/Inputs/ResourceSelect";
import Select from "../../../../../components/Inputs/Select";
import { useCustomFields } from "../../../../Settings/CustomFields/context";
import {
    getSettingsResourceSearchFilters,
    renderPeopleCustomFieldLabel,
} from "../../../../../utils/helpers/settings";

export const usePeopleCustomFieldsFilters = () => {
    const { t } = useTranslation();
    const { peopleCustomFields } = useCustomFields();

    return useMemo(() => {
        return [
            {

                id: "custom-field",
                Header: t("home-custom-fields"),
                filter: "resource-select",
                canFilter: true,
                Filter: (
                    <ResourceSelect
                        resourcePath="/custom-field/people"
                        mode="multiple"
                        renderLabel={renderPeopleCustomFieldLabel}
                        getSearchFilters={getSettingsResourceSearchFilters}
                        hasSearch
                    />
                ),
            },
            {
                id: "home-custom-fields",
                canFilter: true,
                children: (peopleCustomFields || []).map((customField) => {
                    return {
                        id: customField.code,
                        Header: renderPeopleCustomFieldLabel(customField),
                        filter: customField.type === "select" ? "select" : "text",
                        canFilter: true,
                        Filter: customField.type === "select" ? (
                            <Select mode="multiple">
                                {customField.options.map((option) => (
                                    <Select.Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        ) : undefined,
                    };
                }),
            },
        ]
    }, [peopleCustomFields, t]);
}